module.exports = __webpack_public_path__ + "static/media/tomato.31231bad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/tomato.svg
// module id = 40
// module chunks = 0